package team.platforma.multiplatform_material_extension.calendar.calendar_period.api

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import kotlinx.datetime.Clock
import kotlinx.datetime.DatePeriod
import kotlinx.datetime.TimeZone
import kotlinx.datetime.plus
import kotlinx.datetime.todayIn
import team.platforma.multiplatform_material_extension.calendar.calendar_period.core_ui.CalendarPeriodImpl
import team.platforma.multiplatform_material_extension.calendar.properties.CalendarViewProperties
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarBadges
import team.platforma.multiplatform_material_extension.calendar.utils.CalendarRange
import team.platforma.multiplatform_material_extension.calendar.utils.setStandardCalendarRange
import team.platforma.multiplatform_material_extension.util.gestures.HorizontalGestures

@Composable
fun CalendarPeriod(
    modifier: Modifier? = null,
//    initializeDate: LocalDate? = null,
//    onDateSelected: (LocalDate) -> Unit,
//    initializeMonth: Int? = null,
//    initializeYear: Int? = null,
    calendarRange: CalendarRange? = null,
//    onMonthSelected: (List<LocalDate>) -> Unit = {},
    horizontalGestures: HorizontalGestures? = null,
    properties: CalendarViewProperties? = null,
    calendarBadges: CalendarBadges? = null
) {

    val currentDate = Clock.System.todayIn(TimeZone.currentSystemDefault())
    val initializeCalendarRange = calendarRange ?: setStandardCalendarRange(currentDate)

    CalendarPeriodImpl(
        modifier = modifier ?: Modifier,
        initFirstDate = currentDate ,
        initSecondDate = currentDate.plus(DatePeriod(days = 1)),
        properties = properties ?: CalendarViewProperties(),
        onMonthYearChange = { change ->

        },
        calendarRange = initializeCalendarRange,
        horizontalGestures = horizontalGestures,
        calendarBadges = calendarBadges,
        onPeriodSelected = { firstDate, secondDate ->  
            
        },
        customStyle = null,
        clearPeriod = false,
        onPeriodCleared = {

        },
        showClearButton = true
    )
}